import { render } from "./HoverEditor.vue?vue&type=template&id=3f951d2a&scoped=true&ts=true"
import script from "./HoverEditor.vue?vue&type=script&lang=ts"
export * from "./HoverEditor.vue?vue&type=script&lang=ts"

import "./HoverEditor.vue?vue&type=style&index=0&id=3f951d2a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f951d2a"]])

export default __exports__